import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import api from "@/lib/api";

export default function CatchRedirect() {
  const location = useLocation();
  const navigate = useNavigate();
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    let live = true;
    api
      .get("/redirects")
      .then(({ data }) => {
        if (!live) return;
        const key = decodeURIComponent(location.pathname).replace(/\/+$/, "").replace(/^\//, "").toLowerCase();
        const target = data[key] || data[location.pathname];
        if (target) {
          navigate(target, { replace: true });
        } else {
          setChecked(true);
        }
      })
      .catch(() => live && setChecked(true));
    return () => {
      live = false;
    };
  }, [location.pathname, navigate]);

  return (
    <div data-testid="not-found-page" className="mx-auto flex min-h-screen max-w-[1440px] flex-col justify-center px-5 py-32 md:px-10">
      <p className="font-serif text-8xl font-medium text-ash">404</p>
      <h1 className="mt-4 font-serif text-4xl font-medium tracking-tight md:text-6xl">
        This page has been re-engineered<span className="text-progress">.</span>
      </h1>
      <p className="mt-4 max-w-md text-base text-obsidian/60">
        The page you&apos;re looking for doesn&apos;t exist — but the important ones are all a click away.
      </p>
      <div className="mt-10 flex flex-wrap gap-4">
        <Link to="/" data-testid="not-found-home" className="bg-obsidian px-6 py-3 text-sm font-bold uppercase tracking-[0.14em] text-paper transition-colors hover:bg-progress">
          Back to home
        </Link>
        <Link to="/services" data-testid="not-found-services" className="border border-obsidian px-6 py-3 text-sm font-bold uppercase tracking-[0.14em] transition-colors hover:border-progress hover:text-progress">
          Our services
        </Link>
      </div>
    </div>
  );
}
